import { useEffect, useState } from "react";
import './konzept.css';
import { Feature } from "../../components";
import { useTranslation } from 'react-i18next';
import api from '../../api/axios';


const Konzept = ({ navbarHeight }) => {
    const { t } = useTranslation();
    const [videoSrc, setVideoSrc] = useState(""); // video from DB
    const [videoLoaded, setVideoLoaded] = useState(false); // for fade-in
    const [pictureSrc, setPictureSrc] = useState("");

    // Navbar height handling is now done via CSS padding
    useEffect(() => {
        const fetchVideo = async () => {
            try {
                const response = await api.get("/user/getwebsitevideo");
                setVideoSrc(response.data.video); // base64 string
            } catch (err) {
                console.error("Error fetching video:", err);
            }
        };

        fetchVideo();

        const fetchPicture = async () => {
            try {
                const pictureId = 7; // 🔹 hardcoded for now, can vary per site later
                const response = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(response.data.picture); // base64 string
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        fetchPicture();
    }, [navbarHeight]);

    return (
        <div className="wrapper-concept" id="concept">
            <div className="description-wrapper">
                <div className={`video-overlay ${videoLoaded ? 'fade-in' : ''}`}>
                    {videoSrc ? (
                        <video controls src={videoSrc} width='100%' height='100%' autoPlay loop muted onCanPlay={() => setVideoLoaded(true)}></video>
                    ) : (
                        <p>{t('LoadingVideo')}</p>
                    )}
                </div>
                <div className="concept-description">
                    <div id="description-header">
                        <h1>{t('ItsA')}</h1>
                        {pictureSrc ? (
                            <img id="logo" src={pictureSrc} alt="Barmatch" />
                        ) : (
                            <p>{t('LoadingLogo')}</p>
                        )}
                        <h1>!</h1>
                    </div>
                    <div className="concepct-description-child" id="description-txt">
                        <p>{t('ConceptTextIntro')}</p>
                        <ul className="concept-bullets">
                            <li><strong>{t('ConceptBullet1Title')}</strong> {t('ConceptBullet1Text')}</li>
                            <li><strong>{t('ConceptBullet2Title')}</strong> {t('ConceptBullet2Text')}</li>
                            <li><strong>{t('ConceptBullet3Title')}</strong> {t('ConceptBullet3Text')}</li>
                        </ul>
                        <p>{t('ConceptTextOutro')}</p>
                    </div>
                </div>
            </div>
            <div className="short-content">
                <Feature title={t('FeatureTitle1')} text={t('FeatureText1')}></Feature>
                <Feature title={t('FeatureTitle2')} text={t('FeatureText2')}></Feature>
                <Feature title={t('FeatureTitle3')} text={t('FeatureText3')}></Feature>
            </div>
        </div>
    )
}

export default Konzept